<template>
  <div class="vimeo-video-field-settings">
    <div class="caption grey--text mb-3">
      Preview Clip Defaults — used when auto-generating clips for this field.
    </div>
    <div class="d-flex align-center" style="gap: 16px">
      <v-text-field
        v-model.number="localValue.clip_count"
        label="Clip count"
        type="number"
        min="1"
        max="10"
        hide-details
        dense
        outlined
        style="max-width: 110px"
      />
      <v-text-field
        v-model.number="localValue.clip_duration"
        label="Clip duration (s)"
        type="number"
        min="1"
        max="30"
        hide-details
        dense
        outlined
        style="max-width: 130px"
      />
    </div>
  </div>
</template>

<script>
const DEFAULTS = { clip_count: 3, clip_duration: 3 };

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      localValue: {
        ...DEFAULTS,
        ...this.value,
      },
    };
  },
  watch: {
    localValue: {
      deep: true,
      handler() {
        this.$emit("update", { ...this.localValue });
      },
    },
    value: {
      deep: true,
      immediate: true,
      handler() {
        if (JSON.stringify(this.value) !== JSON.stringify(this.localValue)) {
          this.localValue = { ...DEFAULTS, ...this.value };
        }
      },
    },
  },
};
</script>

<style scoped lang="scss"></style>
